import axios from 'lib/axios'

export const checkUserSignedInApi = async () => {
  return await axios.get('/check_sign_in')
}

export const checkQuoteServiceAvailibilityApi = async () => {
  return await axios.get('/insurance/quote_services/status')
}
